var sliderSettings = {
  loop: true,
  dots: false,
  autoWidth: true,
  autoHeight: false,
  items:4,
  margin:20,
  nav: true,
  responsive: {
    0: {
      items: 1,
      // center: true,
    },
    751: {
      items: 2
    }, 
    1100: {
      items: 3
    },
    1250: {
      items: 4
    }
  }
}

function bestOfTheRest(){
  let x = '.best-of-the-rest .grid';
  document.querySelectorAll(x).forEach(function(){ 
    $(x).addClass('owl-carousel').addClass('owl-theme');
    $(x).owlCarousel(sliderSettings).trigger('refresh.owl.carousel');
  })

  // everyday low price range page (display nav)
  document.querySelectorAll('.page--low-price-range .best-of-the-rest .owl-nav.disabled').forEach(function(){ $('.page--low-price-range .best-of-the-rest .owl-nav.disabled').removeClass('disabled') })
  
}
function productRecommendSlider(){
  let x = '.product-recmd-slider';
  $(x).addClass('owl-carousel').addClass('owl-theme');
  $(x).owlCarousel(sliderSettings).trigger('refresh.owl.carousel');
}

document.addEventListener("DOMContentLoaded", function() {
  bestOfTheRest();
  
  // Product recommendation slider
  waitForElm('.product-recmd-slider').then((elm) => {
    productRecommendSlider() // slider init
  });
});